import React from "react";
import "./styles.scss";
import beforePreHireImage from "./before-pre-hire-appointment.png";
import AfterPreHireImage from "./pre-hire-appointment-completed.png";
import StartDateConfirmedImage from "./start-date-confirmed.png";
import { H2, H3 } from "../typography";
import { Col } from "@amzn/stencil-react-components/layout";
import useArb from "../../hooks/use-arb";

interface StatusInfoProps {
  nheCompleted: boolean;
  startDateStatus: string;
}

export const StatusInfo = ({
  nheCompleted,
  startDateStatus,
}: StatusInfoProps) => {
  const image = nheCompleted ? (
    startDateStatus === "TENTATIVE" ? (
      <img
        src={AfterPreHireImage}
        alt="Application status image"
        className="image"
      />
    ) : (
      <img
        src={StartDateConfirmedImage}
        alt="Application status image"
        className="image"
      />
    )
  ) : (
    <img
      src={beforePreHireImage}
      alt="Application status image"
      className="image"
    />
  );

  const bundle = useArb("HVHChecklistPantherResource");
  const h2 = bundle.getMessage("Checklist-ApplicationStatus-H2");
  const h3 = bundle.getMessage("Checklist-ApplicationStatus-H3");
  const firstDay = bundle.getMessage("Checklist-ApplicationStatus-FirstDay");
  const appointment = bundle.getMessage(
    "Checklist-ApplicationStatus-Appointment"
  );

  const text = nheCompleted ? (
    startDateStatus === "TENTATIVE" ? (
      <>
        <H2 textAlign="center">{h2}</H2>
        <H3 textAlign="center">{h3}</H3>
      </>
    ) : (
      <H2 textAlign="center">{firstDay}</H2>
    )
  ) : (
    <H2 textAlign="center">{appointment}</H2>
  );

  return (
    <>
      <Col className="stepper-wrapper" gridGap="1rem" alignItems="center">
        {image}
        {text}
      </Col>
    </>
  );
};
